<template>
  <div class="order_container">
    <div class="operation_wrap flex-between">
      <div class="order_state_wrap flex-rowl">
        <div
          class="order_state_item flex-rowl"
          v-for="(item, index) in screenList"
          :key="index"
          @click="handleState(item)"
        >
          <span
            class="iconfont"
            :class="item.isActive ? 'icon-danxuanyixuan1' : 'icon-quanxuan'"
          ></span>
          <p>{{ item.mul_txt }}</p>
        </div>
      </div>
      <div class="search_wrap_box flex-rowl">
        <div class="search_txt">Search</div>
        <div class="search_wrap flex-between">
          <el-input
            v-model="params.keyword"
            :placeholder="$t('Enter keywords to search')"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <div class="search_btn flex-rowc" @click="handleSearch">
            <i class="iconfont icon-chazhaotubiao"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="main_container"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="list_wrap" v-if="!loading && dataList.length > 0">
        <div
          class="item_wrap flex-rowl"
          v-for="item in dataList"
          :key="item.id"
        >
          <div class="item_thumb" @click="handleDetail(item.id, item.openid)">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.goods[0].img"
              fit="cover"
            ></el-image>
          </div>
          <div class="item_content flex-between">
            <div class="item_content_block">
              <p class="flex-rowl">
                {{ $t("Order number") }}：<span>{{ item.orderno }}</span>
                <span
                  class="iconfont icon-fuzhi"
                  :data-clipboard-text="item.orderno"
                  @click="handleCopyBtn"
                ></span>
              </p>
              <p>
                {{ $t("Creation time") }}：<span>{{
                  item.createdate | formatDate
                }}</span>
              </p>
              <p>
                {{ $t("Order area") }}：<span>{{ COUNTRY.countryname_e }}</span>
              </p>
            </div>
            <div class="item_content_block">
              <h2>
                {{ item.goods[0].multilingualCommodityname }}
                <span
                  class="iconfont icon-fuzhi"
                  :data-clipboard-text="item.multilingualCommodityname"
                  @click="handleCopyBtn"
                ></span>
              </h2>
              <div class="item_content_block_list">
                <div
                  class="item_content_block_item flex-rowl"
                  v-for="(itemChild, indexChild) in item.newGoodsjson"
                  :key="indexChild"
                >
                  <p
                    v-for="(attrItem, attrindex) in itemChild.attr"
                    :key="attrindex"
                  >
                    #{{ attrItem.split(":")[1] }}
                  </p>
                  <p class="flex-rowl">
                    <span class="iconfont icon-dangeyichuicon"></span
                    >{{ itemChild.num }}
                  </p>
                </div>
              </div>

              <p>Totally:{{ item.totalNum }}</p>
            </div>
            <div
              class="item_content_block item_content_block_last"
              @click="handleDetail(item.id, item.openid)"
            >
              <p class="flex-rowl">
                <span class="label">Order Price:</span
                ><span class="unit">{{
                  item.currency_trans_list[0].moneyslog
                }}</span
                >{{ item.totalremain_trans }}
              </p>
              <p class="flex-rowl">
                <span class="label">Amount Paid:</span
                ><span class="unit">{{
                  item.currency_trans_list[0].moneyslog
                }}</span
                >{{ item.totalpaynum_trans }}
              </p>
              <p class="flex-rowl">
                <span class="label">Amount to be Settled:</span
                ><span class="unit">{{
                  item.currency_trans_list[0].moneyslog
                }}</span
                >{{ item.totalremain_trans }}
              </p>
              <p class="flex-rowl">
                <span class="label">Order Status:</span
                >{{
                  item.ordertalk == 1
                    ? $t("In progress")
                    : item.ordertalk == 2
                    ? $t("Completed")
                    : item.ordertalk == 3
                    ? $t("Closed")
                    : $t("None")
                }}
              </p>
              <p class="flex-rowl">
                <span class="label">Progress Status:</span
                >{{
                  item.orderstate == "待发货"
                    ? $t("To be shipped")
                    : item.orderstate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="no_data" v-if="!loading && dataList.length == 0">
        <el-empty description="暂无内容"></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="commodity_pagin flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="8"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
  
  <script>
import { encryptstringadd } from "../../api/api";
import { getOrderListWeb } from "../../api/shop";
import { calculator } from "../../utils/decimal";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "orderList",
  data() {
    return {
      loading: false,
      qyid: 180,
      screenList: [
        {
          id: 1,
          txt: "支付未完成",
          mul_txt: "Pending Payment",
          type: "paystate",
          value: 0,
          isActive: false,
        },
        {
          id: 2,
          txt: "待审核",
          mul_txt: "Pending Shipment",
          type: "ischeck",
          value: 0,
          isActive: false,
        },
        {
          id: 3,
          txt: "审核通过",
          mul_txt: "Shipped",
          type: "ischeck",
          value: 1,
          isActive: false,
        },
        {
          id: 4,
          txt: "审核不通过",
          mul_txt: "Delivered",
          type: "ischeck",
          value: 2,
          isActive: false,
        },
        {
          id: 5,
          txt: "全部",
          mul_txt: "All Status",
          type: "",
          value: "",
          isActive: false,
        },

        // { txt: "已支付完成", type: "paystate", value: 1 },
        // { txt: "退费申请待审核", type: "returntalk", value: 1 },
        // { txt: "退费申请不通过", type: "returntalk", value: 2 },
        // { txt: "退款中", type: "orderstate", value: "已申请退费" },
        // { txt: "已退款", type: "orderstate", value: "已退费" },
      ],
      select: "全部",
      dataList: [],
      listTotal: 0,
      type: "",
      params: {
        openid: "",
        ordertype: "", // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: "", // 支付状态
        orderstate: "", // 订单状态
        pageindex: 1,
        pagesize: 8,
        currency_trans: "",
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  created() {
    this.params.openid = this.$store.state.OPENID;
    this.params.currency_trans = this.USERINFO.countryExrateObj.id;
    this.getOrderListWeb();
  },
  methods: {
    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualCommodityname = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualCommodityname = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualCommodityname = v[key3]
            ? v[key3]
            : v[key2]
            ? v[key2]
            : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualCommodityname = v[key4]
            ? v[key4]
            : v[key2]
            ? v[key2]
            : v[key1];
        }
      });
      return dataList;
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getOrderListWeb();
    },
    // 搜索
    handleSearch() {
      this.getOrderListWeb();
    },
    // 筛选
    handleScreen(item) {
      if (item.con == "" && item.type == "") {
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "ischeck") {
        this.params.ischeck = item.con;
        this.params.returntalk = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "returntalk") {
        this.params.returntalk = item.con;
        this.params.ischeck = "";
        this.params.paystate = "";
        this.params.orderstate = "";
      } else if (item.type == "paystate") {
        this.params.paystate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.orderstate = "";
      } else if (item.type == "orderstate") {
        this.params.orderstate = item.con;
        this.params.returntalk = "";
        this.params.ischeck = "";
        this.params.paystate = "";
      }
      this.select = item.txt;
      this.getOrderListWeb();
    },
    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.getOrderListWeb();
    },
    // 状态
    handleState(item) {
      // 先将所有筛选项的选中状态设为 false
      this.screenList.forEach((v) => {
        v.isActive = false;
      });
      // 再将当前点击的筛选项的选中状态设为 true
      item.isActive = true;

      // 重置 params 中的筛选条件
      this.params.ischeck = "";
      this.params.paystate = "";

      // 根据当前选中项的 type 类型给相对应的 params 中添加 value 值
      if (item.type) {
        this.params[item.type] = item.value;
      }

      this.getOrderListWeb();
    },
    getOrderListWeb() {
      this.loading = true;
      getOrderListWeb(this.params).then((res) => {
        let newRes = res.list;
        newRes.forEach((v) => {
          // 判断goodsjson是否存在，如果存在则转换为数组
          if (v.goodsjson) {
            v.newGoodsjson = JSON.parse(v.goodsjson);
          }
          if (v.goods.length > 0) {
            v.totalNum = 0;
            v.goods.forEach((v1) => {
              v.totalNum += v1.num;
            });
            this.handleMultilingualName(
              v.goods,
              "commodityname",
              "commodityname_e",
              "commodityname_y",
              "commodityname_m"
            );
          }
        });
        this.dataList = newRes;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    handleDetail(id, openid) {
      this.encryptstringadd("cRetailOrderDetail", {
        id,
        openid,
        type: "cRetailOrderList",
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning(this.$t("Opening soon"));
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".icon-fuzhi");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.order_container {
  padding: 0;
  .operation_wrap {
    margin-bottom: 11px;
    .order_state_wrap {
      font-size: 16px;
      color: #333333;
      .order_state_item {
        margin-right: 25px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        .icon-danxuanyixuan1 {
          font-size: 28px;
          color: #4f4f4f;
          margin-right: 10px;
        }
        .icon-quanxuan {
          font-size: 30px;
          margin-right: 10px;
        }
      }
    }
    .search_wrap_box {
      .search_txt {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        margin-right: 8px;
      }
      .search_wrap {
        background: #fff;
        width: 390px;
        height: 50px;
        border-radius: 45px;
        border: none;
        padding: 0 20px;
        box-sizing: border-box;
        /deep/.el-input__inner {
          border: none;
        }
        .icon-chazhaotubiao {
          font-size: 22px;
        }
      }
    }
  }

  .main_container {
    height: 55vh;
    overflow-y: scroll;
    margin-bottom: 40px;
    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
    .list_wrap {
      .item_wrap {
        background: #fff;
        padding: 20px 20px 35px;
        box-sizing: border-box;
        border-radius: 30px;
        align-items: flex-start;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .item_thumb {
          width: 120px;
          height: 150px;
          border-radius: 15px;
          overflow: hidden;
        }
        .item_content {
          align-items: flex-start;
          margin-left: 20px;
          font-size: 16px;
          color: #333333;
          flex: 1;
          .item_content_block {
            width: calc((100% - 40px) / 3);
            flex-shrink: 0;
            h2 {
              font-weight: bold;
            }
            p {
              margin-bottom: 10px;
            }
            .item_content_block_list {
              margin: 18px 0 25px;
              .item_content_block_item {
                margin-bottom: 14px;
                flex-wrap: wrap;
                p {
                  color: #999999;
                  width: calc((100% - 40px) / 3);
                  flex-shrink: 0;
                  margin-bottom: 0;
                  .icon-dangeyichuicon {
                    font-size: 10px;
                    margin-right: 10px;
                  }
                }
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
            &.item_content_block_last {
              .label {
                flex-shrink: 0;
                width: 160px;
              }
              .unit {
                margin-right: 9px;
              }
            }
            .icon-fuzhi {
              margin-left: 10px;
              font-weight: 400;
              cursor: pointer;
            }
          }
        }
      }
    }
    // .shop_list {
    //   .shop_more {
    //     height: 50px;
    //     border-top: 1px solid #fff;
    //   }
    // }
    // .red {
    //   color: #ee0032;
    // }
  }
  .intro_box {
    .block {
      margin-right: 30px;
    }
    cursor: pointer;
    .shop_item {
      margin-bottom: 5px;
      font-size: 14px;
      align-items: flex-start;
      .img {
        margin-right: 10px;
      }
    }
  }
}
</style>